import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { EssenceBalance } from '@sorare/core/src/components/balance/EssenceBalance';
import { GemsBalance } from '@sorare/core/src/components/commonGame/GemsBalance';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { getCommonCardShardsCount } from '@sorare/core/src/lib/currentUser';

type Props = {
  cardSetSlugs: string[];
};
export const SeriesBalance = ({ cardSetSlugs }: Props) => {
  const { currentUser } = useCurrentUserContext();

  return (
    <Horizontal>
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
      {cardSetSlugs?.map(slug => (
        <EssenceBalance
          key={slug}
          value={getCommonCardShardsCount(currentUser, slug) || 0}
          rarity={Rarity.common}
          cardSetSlug={slug}
        />
      ))}
    </Horizontal>
  );
};
